import { Field } from 'formik';
import { useRef } from 'react';

export const ReactFileField = ({ className = '', fieldProps: { onChange, ...fieldProps }, ...props }) => {
  const inputRef = useRef();

  const defaultOnChange = (event) => {
    const files = event.target.files;
    const value = event.target.multiple ? files : files[0] || undefined;
    if (typeof onChange === 'function') {
      onChange(value, event);
    }
  };

  return (
    <>
      {/*  @ts-ignore*/}
      <button type="button" className="file-field-button" onClick={() => inputRef?.current.click()}>
        Upload an image
      </button>
      {/*  @ts-ignore*/}
      <input type="file" ref={inputRef} name={props.field.name} className="h-0" onChange={defaultOnChange} {...fieldProps} />
    </>
  );
};

/**
 *
 * @param {Partial<HTMLInputElement>} props
 * @returns {JSX.Element}
 * @constructor
 */
export const FileField = ({ ...props }) => {
  if (props.accept === 'images') {
    props.accept = 'image/jpg, image/jpeg, image/png, image/webp';
  }

  if (props.accept === 'videos') {
    props.accept = 'video/*';
  }

  return <Field component={ReactFileField} fieldProps={props} />;
};
